module.exports = __webpack_public_path__ + "static/img/Layers.138e497c.svg";